<div class="p-grid p-justify-center">
    <div class="p-col p-col-align-center">
        <p-toast [style]="{marginTop: '80px'}"></p-toast>
    </div>
</div>
<div class="p-grid p-justify-center">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="p-col">
        <p-panel header="Autenticação Corporativa">
            <div class="ui-grid ui-grid-responsive ui-grid-pad ui-fluid" style="margin: 10px 0px">
                <div class="ui-grid-row">
                    <div class="ui-grid-col-2">
                        {{ 'CORE.AUTH.LOGIN' | translate }}
                    </div>
                    <div class="ui-grid-col-6">
                        <input pInputText type="text" formControlName="username"
                               [placeholder]="'CORE.AUTH.LOGIN_PLACEHOLDER' | translate"/>
                    </div>
                    <div class="ui-grid-col-4">
                        <p-message severity="error" [text]="'CORE.AUTH.REQUIRED' | translate"
                                   *ngIf="!loginForm.controls['username'].valid&&loginForm.controls['username'].dirty"></p-message>
                    </div>
                </div>
                <div class="ui-grid-row">
                    <div class="ui-grid-col-2">
                        {{ 'CORE.AUTH.PASSWORD' | translate }}
                    </div>
                    <div class="ui-grid-col-6">
                        <input pInputText type="password" formControlName="password"
                               [placeholder]="'CORE.AUTH.PASSWORD_PLACEHOLDER' | translate"/>
                    </div>
                    <div class="ui-grid-col-4">
                        <p-message severity="error" [text]="'CORE.AUTH.REQUIRED' | translate"
                                   *ngIf="!loginForm.controls['password'].valid&&loginForm.controls['password'].dirty"></p-message>
                    </div>
                </div>
                <div class="ui-grid-row">
                    <div class="ui-grid-col-2"></div>
                    <div class="ui-grid-col-6">
                        <button pButton type="submit" [label]="'CORE.AUTH.CONFIRM' | translate"
                                [disabled]="!loginForm.valid"></button>
                    </div>
                    <div class="ui-grid-col-4"></div>
                </div>
            </div>
        </p-panel>
    </form>
</div>
